import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Input } from "antd"
import { Index } from "elasticlunr"


const Search = ({ placeholder, searchIndex, updateResults, buildResult }) => {


  //const [index, setIndex] = useState(Index.load(searchIndex))
  const [query, setQuery] = useState(null)
  const [message, setMessage] = useState(null)
  const index = Index.load(searchIndex)

  // perform search on query change and update results
  useEffect(() => {
    if(query === "") {
      setQuery(null)
    }
    const results = query ? index.search(query ? query : "*", {expand:true}) : null // use a wildcard so null queries return all results 
    if(query && (results && results.length === 0)) {
      setMessage("No results found.")
    }
    else {
      setMessage(null)
    }
    updateResults(results ? results.map(({ ref }) => buildResult(index.documentStore.getDoc(ref))) : null)
  }, [query])

  return (
    <div>
      <Input.Search
        placeholder={placeholder}
        onSearch={(v, e) => setQuery(v)}
        onChange={(e) => setQuery(e.target.value)}
      />
      {message}
    </div>
  )
}

Search.propTypes = {
  searchIndex: PropTypes.object,
  updateResults: PropTypes.func,
  buildResult: PropTypes.func,
  placeHolder: PropTypes.string,
}

export default Search